import { LanguagesEnum } from '../handlers/TranslationsHandler';

export const localeDate = (language: LanguagesEnum) =>
  new Date().toLocaleString(languageConversion[language], {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });

export const languageConversion = {
  EN: 'en-GB',
  DE: 'de-DE'
};
